// 

function pathjoin(...pathParts) {
  let urlObject;

  // clean unwanted values
  let parts = pathParts.filter(
    arg => typeof arg === 'string' || typeof arg === 'number',
  );

  const [first, ...truncatedParts] = parts;
  const cleanedFirst = `${first}`.trim();
  const cleanedLast = `${parts[parts.length - 1]}`.trim();

  // Try to build an URL object to handle urls as first path
  try {
    urlObject = new URL(cleanedFirst);
    parts = [urlObject.pathname, ...truncatedParts];
  } catch (e) {
    // nothing to do
  }

  // clean paths and remove unwanted `/`
  const cleanedParts = parts
    .map(pathname => {
      return `${pathname}`.trim().split('/').filter(Boolean).join('/');
    })
    .filter(Boolean);

  let pathname = cleanedParts.join('/');

  if (cleanedFirst.startsWith('/')) {
    pathname = `/${pathname}`;
  }

  if (parts.length > 1 && cleanedLast.endsWith('/')) {
    pathname = `${pathname}/`;
  }

  if (urlObject) {
    const url = new URL(pathname, urlObject.origin);
    pathname = url.href;
  }

  return pathname;
}

export { pathjoin };
